import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  gridContainer: {
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    backgroundColor: '#f0f0f0',
    border: '1px solid #ccc',
    // width: '45%',
    height: '100vh',
    borderRadius: 5,
    margin: 10,
    paddingBottom: theme.spacing(1),
  },
  gridItemFirst: {
    width: '20%'
    // flexBasis: '10%',
  },
  gridItemSecond: {
    width: '40%'
    // flexBasis: '10%',
  },
  gridItemThird: {
    width: '40%'
    // flexBasis: '10%',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  paper: {
    width: '96%',
    margin: 5
  },
  itemDetail: {
    width: '99%',
    paddingBottom: theme.spacing(1.5),
    display: 'flex',
    overflowX: 'auto',
    overflowY: 'hidden',
    whiteSpace: 'nowrap'
  },
  itemDetailInput: {
    display: 'flex',
    width: '100%',
    marginTop: theme.spacing(1)
  },
  itemDetailQuestions: {
    width: '100%',
    height: '60%',
    overflowY: 'auto',
    whiteSpace: 'nowrap',
    margin: '10px 0 10px',
    padding: '0 10px 0 10px'
  },
  cardButton: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    maxHeight: 150,
    borderRadius: 8,
    cursor: 'pointer',
    transition: 'background-color 0.3s ease-in-out',
    '&:hover': {
      backgroundColor: '#e0e0e0',
    },
  },
  title: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  description: {
    fontSize: 14,
    textAlign: 'center',
  },
  cardAutocomplete: {
    margin: 5,
  },
  finishBtn: {
    margin: '40px auto 20px',
    display: 'flex'
  }
}))
